// ---------------------------------------------- modules import
import { ThunkAction } from "redux-thunk";

import Actions from "./actions";
import { AuthAction } from "./common";
import { AppState } from "../rootReducer";
import { IThunkExtraArgument } from "../../index";
import { idbLogin, idbLogout } from "../service/idbFunction";

// ---------------------------------------------- thunk actions
export const thunkLogin = (
  email: string,
  password: string
): ThunkAction<void, AppState, IThunkExtraArgument, AuthAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(result => {
        if (result.user)
          idbLogin(result.user.uid)
        dispatch(Actions.loginSuccess())
      })
      .catch(error => dispatch(Actions.loginError(error.message)));
  };

export const thunkLogout = (): ThunkAction<
  void,
  AppState,
  IThunkExtraArgument,
  AuthAction
  > => (dispatch, getAppState, { getFirebase }) => {
    const firebase = getFirebase();
    idbLogout()
    firebase
      .auth()
      .signOut()
      .then(() => dispatch(Actions.logoutSuccess()))
      .catch(error => dispatch(Actions.logoutError(error.message)));
  };
